import React from "react";
import PropTypes from "prop-types";

import { Paragraph, Title } from "@/components/atoms/Typography/styles";

import { TextWrapper } from "./styles";

function Article({ textContent, textIndent, title, titlePosition }) {
  return (
    <div className="flex flex-col gap-4 h-full mt-[0.3rem] max-h-[400px] overflow-y-auto pl-8 pr-6 pb-8 pt-2">
      {title && <Title widthFull>{title}</Title>}
      {textContent?.map((el) => (
        <div className="mt-5" key={el.title}>
          <Title className="mb-3" titlePosition={titlePosition} size="base">
            {el.title}
          </Title>
          {el.paragraphs.map((item) => (
            <TextWrapper key={item?.paragraph} textIndent={textIndent} justify>
              {item?.renderAsHtml ? (
                <Paragraph
                  dangerouslySetInnerHTML={{
                    __html: item.paragraph,
                  }}
                  indent={item?.indent}
                  justify
                />
              ) : (
                <Paragraph indent={item?.indent} justify>
                  {item?.paragraph}
                </Paragraph>
              )}
            </TextWrapper>
          ))}
        </div>
      ))}
    </div>
  );
}

Article.propTypes = {
  textContent: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      paragraphs: PropTypes.arrayOf(
        PropTypes.shape({
          paragraph: PropTypes.string.isRequired,
          renderAsHtml: PropTypes.bool,
        }),
      ),
    }),
  ),
  textIndent: PropTypes.string,
  title: PropTypes.string,
  titlePosition: PropTypes.string,
};

export default Article;
